<template>
    <div>
      <KidHeader :style="{ 'max-width': '575px', 'margin': '0 auto', 'padding-left': '15px', 'padding-right': '15px' }" :profileId="profileId" :serialNumber="serialNumber" />
      <div class="container-fluid">
          <div class="main-container">
              <div class="profile-section mb-2">
                  <div class="pl-2">
                      <span>
                          <a v-if="!serialNumber" class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device'})"><i class="fas fa-long-arrow-alt-left"></i><b>Apps</b></a>
                          <a v-else class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/play-store', query: { profileId: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, filterCategory: this.filterCategory, ageFilter: this.ageFilter, expertRatingFilter: this.expertRatingFilter }})"><i class="fas fa-long-arrow-alt-left"></i> <b>Apps</b></a>
                      </span>
                  </div>
              </div>
              <div class="profile-section mb-2" style="border-bottom: unset;">
                  <div class="nav nav-pills" role="tablist">
                      <a class="nav-link active" href="#usage" id="usageTab" role="tab" data-toggle="tab">Usage</a>
                      <a class="nav-link " href="#info" id="infoTab" role="tab" data-toggle="tab">Info</a>
                  </div>
                  <div class="tab-content p-1">
                      <div class="tab-pane" id="info">
                          <div v-if="applicationDetail && applicationDetail.playStoreDetail">
                              <div class="w-100 text-center p-2 bg" :style="{ backgroundImage: 'url(' + applicationDetail.playStoreDetail.headerImage + ')', height: '200px', 'background-repeat': 'round' } ">
                              </div>
                              <div class="row border-bottom p-2 pl-3 text-center">
                                  <div class="col-xs-2">
                                      <img :src="applicationDetail.playStoreDetail.icon" style="height: 40px; width: 40px;">
                                  </div>&nbsp;
                                  <div class="col-xs-10 pt-2">
                                      <span>{{ applicationDetail.playStoreDetail.title }}</span>
                                      <span class="pl-4" v-if="applicationDetail.playStoreDetail.price > 0">₣ {{ applicationDetail.playStoreDetail.price }}</span>
                                  </div>
                              </div>
                              <div class="p-2 text-center ScrollStyle" style="display: flow-root;white-space:nowrap;border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                                  <div class="text-center" style="display: inline-grid;">
                                      <label :style="{ 'margin': 0 }">
                                          <img v-if="applicationDetail && applicationDetail.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" height="17px" width="auto" />
                                          <img v-else-if="applicationDetail && applicationDetail.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" height="17px" width="auto" />
                                          <img v-else-if="applicationDetail && applicationDetail.expertRating == '16+'" :src="sixteenPlus" height="17px" width="auto" />
                                          <img v-else :src="notRated" height="17px" width="auto" />
                                      </label>
                                      <label class="text-muted" :style="{ 'padding-top': '7px' }">Expert Rating</label>
                                  </div>
                                  <div class="text-center" style="display: inline-grid;" v-if="applicationDetail.playStoreDetail.scoreText">
                                      <span style="height: 32px;">
                                        <StarGoldIcon class="pr-1" />
                                       <b>{{ applicationDetail.playStoreDetail.scoreText }}</b></span>
                                      <label class="text-muted">&nbsp;&nbsp;Google Play</label>
                                  </div>
                                  <div class="pl-3 text-center" style="display: inline-grid;">
                                      <span style="height: 32px;">
                                        <img class="mb-1" v-if="kidsRatingDetail.avgKidsRating >= 3" :src="childPositiveSmile" />
                                        <img class="mb-1" v-else-if="kidsRatingDetail.avgKidsRating >= 2 && kidsRatingDetail.avgKidsRating < 3" :src="childNeutralSmile" />
                                        <img class="mb-1" v-else-if="kidsRatingDetail.avgKidsRating >= 1 && kidsRatingDetail.avgKidsRating < 2" :src="childNegativeSmile" />
                                        <i v-else class="far fa-smile rating-grey" />
                                        <b>&nbsp;{{ overallRating }}</b></span>
                                      <label class="text-muted">Parents & Kids</label>
                                  </div>
                                  <div class="pl-3 text-center" style="display: inline-grid;" v-if="applicationDetail.playStoreDetail.contentRating">
                                      <span style="height: 32px;"><b>{{ applicationDetail.playStoreDetail.contentRating }}</b></span>
                                      <label class="text-muted">Age Group</label>
                                  </div>
                                  <div class="pl-3 text-center" style="display: inline-grid;">
                                      <span style="height: 32px;"><b>{{ applicationDetail.playStoreDetail.genreId.replace(/_/g, ' ').toLowerCase() }}</b></span>
                                      <label class="text-muted">Category</label>
                                  </div>
                                  <!--<div class="pl-3 text-center" style="display: inline-grid;">
                                      <span style="height: 32px;">4+</span>
                                      <label>Age</label>
                                  </div>-->
                              </div>
                              <div class="collapse mt-2 mr-2 footer-full" id="reviewPopup">
                                <div class="card height-100">
                                    <div class="card-body">
                                        <h5 class="text-black pb-2">
                                            <b>Your App Rating</b>
                                            <span class="float-right"><a class="text-black" href="javascript:void(0)" @click="closeRatingPopup()"><CrossCloseIcon /> </a></span>
                                        </h5>
                                        <div class="ScrollStyle" v-if="applicationDetail.appExist == true">
                                          <div class="profile-section mb-1" style="border-bottom: unset;">
                                              <div class="card w-100 background-dark">
                                                  <div class="card-body">
                                                      <img v-if="applicationDetail.playStoreDetail" :src="applicationDetail.playStoreDetail.icon" style="height: 40px; width: 40px;">
                                                      <img v-else :src="applicationDetail.app_icon" style="height: 40px; width: 40px;">
                                                      <span class="pl-2">
                                                        <b v-if="applicationDetail.playStoreDetail">{{ applicationDetail.playStoreDetail.title }}</b>
                                                        <b v-else>{{ applicationDetail.package_name }}</b>
                                                      </span>
                                                  </div>
                                                </div>
                                            </div>
                                            <div>
                                              <label><b>Was it educational for your child?</b></label>
                                              <star-rating v-model:rating="isEducational" :show-rating="false" :star-size="30" />
                                            </div><hr class="rating-hr">  
                                            <div>
                                              <label>
                                                <b>Do you feel it is helping its creativity?</b>
                                              </label>
                                              <star-rating v-model:rating="isPositive" :show-rating="false" :star-size="30" />
                                            </div><hr class="rating-hr">
                                            <div>
                                              <label>
                                                <b>How suitable was the content for your child’s age?</b>
                                                <!--<br><small>Was the app easy for your child to navigate and understand?</small>-->
                                              </label>
                                              <star-rating v-model:rating="isSuitableContent" :show-rating="false" :star-size="30" />
                                            </div><hr class="rating-hr">
                                            <div>
                                              <label>
                                                <b>Was the app easy for your child to navigate and understand?</b>
                                              </label>
                                              <star-rating v-model:rating="isEasyToUnderstand" :show-rating="false" :star-size="30" />
                                            </div><hr class="rating-hr">
                                            <div>
                                              <label><b>Would you recommend it to other parents with kids in the same age group?</b></label>
                                              <div> 
                                                <button type="button" :style="{ 'border-color':'#d2d8dd' }" class="btn btn-light mr-2" :class="{ 'focus': isRecommend == false }" @click="updateIsRecommend(false)">👎 No</button>
                                                <button type="button" :style="{ 'border-color':'#d2d8dd' }" class="btn btn-light" :class="{ 'focus': isRecommend == true }" @click="updateIsRecommend(true)">👍 Yes</button>
                                              </div>
                                            </div><hr class="rating-hr">
                                            <div>
                                              <label><b>Help other parents with your comments:</b></label>
                                              <div class="form-group">
                                                <textarea class="form-control" v-model="review" rows="1"></textarea>
                                              </div>
                                            </div>
                                            <div>
                                                <button type="button" class="btn btn-primary w-100" :disabled="isDisabled" :style="{ 'border-radius': '20px' }" @click="submitParentRating()">
                                                  Submit<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </div>
                              <div class="p-2 text-center" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                                  <button class="btn btn-primary rounded" v-if="applicationDetail.playStoreDetail.free == false && applicationDetail.isAppInstalled == false" >Coming Soon</button>
                                  <div v-else>
                                    <button type="button" v-if="applicationDetail.isAppInstalled == false" class="btn btn-primary rounded" style="width: 90%;" @click="createProfileApplication(applicationDetail.playStoreDetail)">Install</button>
                                    <button type="button" v-else-if="applicationDetail.isSystemApp == false" class="btn btn-danger btn-danger-customized rounded custom-button" style="width: 50%;" @click="uninstallProfileApplication(this.package_name)" :disabled="isDisabled"
                                    :style="{ 'align-items': 'center', 'justify-content': 'center', 'display': 'inline-flex'}">
                                      <TrashIcon />
                                      <b class="text-danger-customized">Uninstall</b></button>
                                      <div class="system-app-warning" v-else>
                                        ⚠️ This is a system app and cannot be uninstalled.
                                      </div>
                                  </div>
                                  <div>
                                    <span class="text-muted" :style="{ 'font-size': '12px' }" v-if="applicationDetail && applicationDetail.playStoreDetail.adSupported == true">
                                      Contains Ads
                                    </span>
                                    <span class="text-muted" :style=  "{ 'font-size': '12px' }" v-if="applicationDetail && applicationDetail.playStoreDetail.offersIAP == true">
                                      &nbsp;&nbsp;In-App Purchase
                                    </span>
                                  </div>
                                  
                              </div>
                              <div class="pt-2 text-center">
                                  <div class="accordion" id="accordionExample">
                                      <div class="card border-bottom">
                                        <div class="card-header custom-header" id="headingOne">
                                          <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left text-black" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                              <b>App Images</b>
                                            </button>
                                          </h2>
                                        </div>
                                    
                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                                          <div class="card-body" style="display: flex;overflow: auto;">
                                            <img v-for="screenshot in applicationDetail.playStoreDetail.screenshots" :key="screenshot" class="p-1" :src="screenshot" style="height: 200px; width: auto;" />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                        <div class="card-header custom-header" id="headingTwo">
                                          <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed text-black" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                              <b>Description </b>
                                              <span class="float-right">
                                                <ArrowDownIcon />
                                              </span>
                                            </button>
                                          </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" >
                                          <div class="card-body">
                                              <p class="text-left" v-html="applicationDetail.playStoreDetail.descriptionHTML"></p>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                        <div class="card-header custom-header" id="headingThree">
                                          <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left text-black collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                              <b>Certificate</b> 
                                              <span class="float-right">
                                                <img v-if="applicationDetail && applicationDetail.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" height="17px" width="auto" />
                                                <img v-else-if="applicationDetail && applicationDetail.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" height="17px" width="auto" />
                                                <img v-else-if="applicationDetail && applicationDetail.expertRating == '16+'" :src="sixteenPlus" height="17px" width="auto" />
                                                <img v-else :src="notRated" height="17px" width="auto" />
                                                &nbsp;
                                                <ArrowDownIcon />
                                              </span>
                                            </button>
                                          </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                          <div class="card-body">
                                            <p class="text-left" v-if="applicationDetail && applicationDetail.expertRatingComment" v-html="applicationDetail.expertRatingComment"></p>
                                            <p class="text-left" v-else>This app has not been certified yet by our expert team.</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                          <div class="card-header custom-header" id="headingThree">
                                            <h2 class="mb-0">
                                              <button class="btn btn-link btn-block text-left text-black collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
                                                <b>Play Store Rating</b> 
                                                <span class="float-right">
                                                  <span class="pl-4"><StarGoldIcon /> {{ applicationDetail.playStoreDetail.scoreText }} &nbsp;</span> 
                                                  <span class="pl-1" v-if="applicationDetail.playStoreDetail.reviews"><CommentIcon /> {{ formatNumber(applicationDetail.playStoreDetail.reviews) }}</span>
                                                  &nbsp;<ArrowDownIcon />
                                                </span>
                                              </button>
                                            </h2>
                                          </div>
                                          <div id="collapseFour" class="collapse" aria-labelledby="headingThree" >
                                            <div class="card-body">
                                              <p class="text-left">Please go to Playstore to view all reviews: 
                                                <a :href="applicationDetail.playStoreDetail.url" target="_blank">{{ applicationDetail.playStoreDetail.title }}</a>
                                              </p>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                          <div class="card-header custom-header" id="headingThree">
                                            <h2 class="mb-0">
                                              <button class="btn btn-link btn-block text-left text-black collapsed" type="button" data-toggle="collapse" data-target="#parentsKidsRating" aria-expanded="false" >
                                                <b>Parents & Kids Rating</b> 
                                                <span class="float-right">
                                                  <label>
                                                    <img class="mb-1" v-if="kidsRatingDetail.avgKidsRating >= 3" :src="childPositiveSmile" />
                                                    <img class="mb-1" v-else-if="kidsRatingDetail.avgKidsRating >= 2 && kidsRatingDetail.avgKidsRating < 3" :src="childNeutralSmile" />
                                                    <img class="mb-1" v-else-if="kidsRatingDetail.avgKidsRating >= 1 && kidsRatingDetail.avgKidsRating < 2" :src="childNegativeSmile" />
                                                    <i v-else class="far fa-smile rating-grey" />
                                                    {{ overallRating }} &nbsp;
                                                  </label> 
                                                  &nbsp;<ArrowDownIcon />
                                                </span>
                                              </button>
                                            </h2>
                                          </div>
                                          <div id="parentsKidsRating" class="collapse" >
                                            <div class="card-body text-left">
                                              <b>Help other parents</b>
                                              <button type="button" class="install-app-btn float-right"  data-toggle="collapse" data-target="#reviewPopup" aria-controls="reviewPopup" aria-expanded="false" aria-label="Toggle navigation"><b>Rate This App</b></button>  
                                              
                                              <div class="parent-rating-section" v-if="parentsRatingDetail">
                                                <div class="pt-4">
                                                  <p><b>Parents</b> <span class="float-right"><b>{{ parentsRatingDetail.parentsRatingAvg }}</b> ({{ parentsRatingDetail.totalParentsRating }} Ratings)</span></p>
                                                </div>
                                                <div>
                                                    <p>
                                                      Educational 
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" :style="{ 'width': parentsRatingDetail.educationalRatingPercentage + '%' }" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ parentsRatingDetail.educationalRatingAvg }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                    <p>
                                                      Supports Creativity
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" :style="{ 'width': parentsRatingDetail.positiveRatingPercentage + '%' }" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ parentsRatingDetail.positiveRatingAvg }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                    <p>
                                                      Suitable Content
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" :style="{ 'width': parentsRatingDetail.suitableRatingPercentage + '%' }" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ parentsRatingDetail.suitableContentRatingAvg }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                    <p>
                                                      Easy to Understand
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" :style="{ 'width': parentsRatingDetail.easyToUnderstaRatingPercentage + '%' }" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ parentsRatingDetail.easyToUnderstandAvg }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                </div>
                                                <div class="ScrollStyle" style="display: -webkit-box;">
                                                  <div class="card mr-3 mb-2" style="width: 11rem; border-bottom: 1px solid rgba(0,0,0,.125)" v-for="review in parentsRatingDetail.lastFiveReviews" :key="review._id">
                                                    <div class="card-body">
                                                      <h5 class="card-title">
                                                        <UserIcon />
                                                        <span class="float-right">
                                                          <UsersBlueIcon />
                                                          <small class="text-black pt-1">&nbsp;<b>{{ (review.isEducational + review.isPositive + review.isSuitableContent + review.isEasyToUnderstand) / 4 }}</b></small>
                                                        </span>
                                                      </h5>
                                                      <p class="card-text" v-if="review.name">{{ review.name }} <span v-if="review.kidName">({{ review.kidName }})</span></p>
                                                      <div style="max-height: 80px; overflow-y: auto;" v-if="review.review">
                                                        <small class="card-text" >{{ review.review }}</small>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div>
                                                  <b>Recommends it to friends:</b> 
                                                  <div>
                                                    <a href="javascript:void(0)">
                                                      <i class="fas fa-thumbs-up" :style="{ 'color': 'gold' }"></i></a> {{ applicationDetail.upVoting }}&nbsp;&nbsp;&nbsp;
                                                    <a href="javascript:void(0)"><i class="fas fa-thumbs-down" :style="{ 'color': 'gold' }"></i></a> {{ applicationDetail.downVoting }}
                                                  </div>
                                                </div>
                                              </div><hr>
                                              <div class="child-rating-section">
                                                <div class="pt-4">
                                                  <p><b>Kids</b> 
                                                    <span class="float-right" :style="{ 'line-height': 'normal' }">
                                                      <label v-if="kidsRatingDetail.avgKidsRating >= 3">
                                                          <img class="mb-1" :src="childPositiveSmile" />
                                                          <b> Positive</b>
                                                        </label> 
                                                        <label v-else-if="kidsRatingDetail.avgKidsRating >= 2 && kidsRatingDetail.avgKidsRating < 3">
                                                          <img class="mb-1" :src="childNeutralSmile" />
                                                          <b> Neutral</b>
                                                        </label>
                                                        <label v-else-if="kidsRatingDetail.avgKidsRating >= 1 && kidsRatingDetail.avgKidsRating < 2">
                                                          <img class="mb-1" :src="childNegativeSmile" />
                                                          <b> Negative</b>
                                                        </label>
                                                        <i v-else class="far fa-smile rating-grey" />
                                                        &nbsp;({{ kidsRatingDetail.totalKidsRating }} Ratings)
                                                    </span>
                                                  </p>
                                                </div>
                                                <div>
                                                    <p>
                                                      <img :src="childPositiveSmile" /><small>&nbsp;Positive</small> 
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" role="progressbar" :style="{ 'width': kidsRatingDetail.positiveRatingPercentage + '%', 'background-color': '#00C52B' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ kidsRatingDetail.positiveRatingCount }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                    <p>
                                                        <img :src="childNeutralSmile" /><small>&nbsp;Neutral</small> 
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" :style="{ 'width': kidsRatingDetail.naturalRatingPercentage + '%', 'background-color': '#737373' }" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ kidsRatingDetail.naturalRatingCount }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                    <p>
                                                      <img :src="childNegativeSmile" /><small>&nbsp;Negative</small> 
                                                      <span class="float-right" :style="{ 'width': '100px', 'padding-top': '8px' }">
                                                        <div class="progress">
                                                          <div class="progress-bar" :style="{ 'width': kidsRatingDetail.negativeRatingPercentage + '%', 'background-color': '#ED0040' }" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                            <label>{{ kidsRatingDetail.negativeRatingCount }}</label>
                                                          </div>
                                                        </div>
                                                      </span>
                                                    </p>
                                                </div>
                                                <div class="ScrollStyle" style="display: -webkit-box;">
                                                  <div class="card mr-3 mb-2" style="width: 11rem; border-bottom: 1px solid rgba(0,0,0,.125)" v-for="review in kidsRatingDetail.lastFiveReviews" :key="review._id">
                                                    <div class="card-body">
                                                      <h5 class="card-title">
                                                        <img :src="kidAvatar" width="30px" height="auto" />
                                                        <span class="float-right">
                                                          <UsersBlueIcon />
                                                          <small class="text-black pt-1">&nbsp;<b>{{ review.kidsRating }}</b></small>
                                                        </span>
                                                      </h5>
                                                      <p class="card-text" v-if="review.name">{{ review.name }} <span v-if="review.kidAge">({{ review.kidAge }} Year)</span></p>
                                                      <div style="max-height: 80px; overflow-y: auto;" v-if="review.review">
                                                        <small class="card-text" >{{ review.review }}</small>
                                                      </div>
                                                      <p class="card-text">{{ HumanReadableDateFormat(review.created_at, true) }}</p>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div>
                                                  <b>Recommends it to friends:</b> 
                                                  <div>
                                                    <a href="javascript:void(0)"><i class="fas fa-thumbs-up" :style="{ 'color': 'gold' }"></i></a> {{ kidsRatingDetail.upVoting }}&nbsp;&nbsp;&nbsp;
                                                    <a href="javascript:void(0)"><i class="fas fa-thumbs-down" :style="{ 'color': 'gold' }"></i></a> {{ kidsRatingDetail.downVoting }}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                        <div class="card-header custom-header" id="headingThree">
                                          <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left text-black collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseThree">
                                              <b>What's New</b> 
                                              <span class="float-right">
                                                <span class="pl-4" v-if="applicationDetail.playStoreDetail">{{ timeSince(applicationDetail.playStoreDetail.updated) }}</span>
                                                &nbsp;<ArrowDownIcon />
                                              </span>
                                            </button>
                                          </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingThree">
                                          <div class="card-body">
                                            <p class="text-left" v-html="applicationDetail.playStoreDetail.recentChanges"></p>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                        <div class="card-header custom-header" id="headingThree">
                                          <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left text-black collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseThree">
                                              <b>App Privacy</b> 
                                              <span class="float-right">
                                                &nbsp;<ArrowDownIcon />
                                              </span>
                                            </button>
                                          </h2>
                                        </div>
                                        <div id="collapseSix" class="collapse" aria-labelledby="headingThree" >
                                          <div class="card-body">
                                            <p class="text-left"><a :href="applicationDetail.playStoreDetail.privacyPolicy">{{ applicationDetail.playStoreDetail.privacyPolicy }}</a></p>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="card border-bottom pt-2">
                                        <div class="card-header custom-header" id="headingThree">
                                          <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left text-black collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseThree">
                                              <b>Information</b>
                                              <span class="float-right">
                                                &nbsp;<ArrowDownIcon />
                                              </span> 
                                            </button>
                                          </h2>
                                        </div>
                                        <div id="collapseSeven" class="collapse" aria-labelledby="headingThree" >
                                          <div class="card-body" v-if="applicationDetail.playStoreDetail">
                                            <p class="text-left text-muted">Provider <span class="float-right text-black">{{ applicationDetail.playStoreDetail.developer }}</span></p>
                                            <p class="text-left text-muted">Category <span class="float-right text-black">{{ applicationDetail.playStoreDetail.genre }}</span></p>
                                            <p class="text-left text-muted">Compatibility <span class="float-right text-black">{{ applicationDetail.playStoreDetail.androidVersionText }}</span></p>
                                            <p class="text-left text-muted">Age Rating <span class="float-right text-black">{{ applicationDetail.playStoreDetail.contentRating }}</span></p>
                                            <p class="text-left text-muted">In-App Purchase 
                                              <span class="float-right text-black" v-if="applicationDetail.playStoreDetail.offersIAP == true">Yes</span>
                                              <span class="float-right text-black" v-else>No</span>
                                            </p>
                                            <p class="text-left text-muted">Copyright <span class="float-right text-black">{{ applicationDetail.playStoreDetail.developerId }}</span></p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                              </div>
                          </div>
                          <span v-if="applicationDetail && !applicationDetail.playStoreDetail" class="text-danger">Unable to fetch application detail from play store.</span>                            
                      </div>
                      <div class="tab-pane active" id="usage" v-if="applicationDetail">
                          <div v-if="applicationDetail.appExist == true">
                              <div v-if="package_name != 'com.nova.kidsfirstphone'">

                                <div class="profile-section mb-2" style="border-bottom: unset;">
                                  <div class="card w-100 background-dark" :style="{ 'max-width': 'unset', 'border-radius': 'unset' }">
                                      <div class="card-body">
                                          <div class="p-2 d-flex align-items-center">
                                              <div class="dropdown-list-image mr-2">
                                                  <img v-if="applicationDetail.playStoreDetail" :src="applicationDetail.playStoreDetail.icon" style="height: 40px; width: 40px;">
                                                  <img v-else :src="applicationDetail.app_icon" style="height: 40px; width: 40px;">
                                              </div>
                                              <div class="font-weight-bold">
                                                  <div class="">
                                                    <b v-if="applicationDetail.playStoreDetail">{{ applicationDetail.playStoreDetail.title }}</b>
                                                    <b v-else>{{ applicationDetail.package_name }}</b>
                                                  </div>
                                              </div>
                                              <div class="ml-auto d-flex flex-column flex-sm-row align-items-sm-center pt-1 text-sm-right">
                                                    
                                                    <!-- Status text wrapper with alignment -->
                                                    <div class="d-flex align-items-center mb-1 mb-sm-0 mr-sm-2">
                                                      <div class="status-text" style="line-height: 1.5; font-size: 0.875rem;">
                                                        <span v-if="isAppEnabled">
                                                          Enabled
                                                          <span v-if="applicationDetail.appEnabledDisabledType">
                                                            ({{ getReasonText(applicationDetail.appEnabledDisabledType) }})
                                                          </span>
                                                        </span>
                                                        <span v-else>
                                                          Disabled
                                                          <span v-if="applicationDetail.appEnabledDisabledType">
                                                            ({{ getReasonText(applicationDetail.appEnabledDisabledType) }})
                                                          </span>
                                                        </span>
                                                      </div>
                                                    </div>

                                                    <!-- Toggle wrapper with alignment -->
                                                    <div class="d-flex align-items-center">
                                                      <label class="switch mb-0">
                                                        <input type="checkbox" v-model="isAppEnabled" @change="toggleAppStatus()" />
                                                        <span class="slider round"></span>
                                                      </label>
                                                    </div>
                                                </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                                
                                <div class="profile-section" :style="{'border-bottom': 'unset'}">
                                    <p><b>Daily Limit</b> - <small class="text-black">In Minute</small></p>
                                    <div class="card w-100 background-dark" :style="{ 'max-width': 'unset', 'border-radius': 'unset' }">
                                        <div class="card-body" :style="{ 'padding': '3px', 'padding-top': '8px', 'padding-bottom': 'unset' }">
                                            <span class="pl-1" :style="{ 'font-size': '15px' }">Enabled Daily Limit</span>
                                            <span class="float-right" :style="{ 'padding-top': '2px' }">
                                                <label class="switch">
                                                    <input type="checkbox" v-model="enableDailyLimit">
                                                    <span class="slider round"></span>
                                                </label>
                                            </span>
                                        </div>

                                        <div class="pt-2 pb-4">
                                            <label class="pl-2" :style="{ 'font-size': '15px' }">Daily Limit
                                              <a href="javascript:void(0)" @click="openDailyLimitPopup()" class="text-black">
                                                <i class="fas fa-info-circle"></i>
                                              </a>
                                            </label>
                                            <div class="float-right" :style="{'width': '55%' }">
                                                <div class="input-group" :style="{ 'width': '100%', 'padding-right': '1px', 'border': '1px solid #dee2e6' }">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text" :style="{ 'background-color': 'white', 'border': 'unset' }" id="btnGroupAddon">
                                                            <a class="text-black" href="javascript:void(0)" @click="decreaseLimit()">
                                                                <ArrowLeftIcon />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <input type="text" class="form-control text-black text-center" :style="{ 'border': 'unset', 'font-weight': 'bold' }" :readonly="enableDailyLimit == false" :class="{ 'text-warning': isDeliveredToDevice == false, 'text-success': isDeliveredToDevice == true }" v-model="dailyLimitTime" @blur="roundOF15()" >
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text" :style="{ 'background-color': 'white', 'border': 'unset' }" id="btnGroupAddon">
                                                            <a class="text-black" href="javascript:void(0)" @click="increaseLimit()">
                                                                <ArrowRightIcon />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--<input type="number" class="form-control" :readonly="enableDailyLimit == false" :class="{ 'text-warning': isDeliveredToDevice == false, 'text-success': isDeliveredToDevice == true }" v-model="dailyLimitTime" step=15 />
                                                <small :class="{ 'text-warning': isDeliveredToDevice == false, 'text-success': isDeliveredToDevice == true }">In Minute.</small>-->
                                            </div>
                                        </div>
                                        <div class="profile-section text-center" >
                                            <button type="button" class="btn btn-primary" :style=" { 'background': '#0073EE', 'border-radius': '20px', 'width': '30%' }" @click="updateDailyLimit()">Save</button>
                                        </div>
                                    </div>
                                </div>
                              </div>
                              <div class="profile-section" :style="{ 'border': 'unset'}">
                                <p class="p-2"><b>Activity</b></p>
                                <div class="btn-group btn-group-justified nav nav-pills justify-content-center" role="tablist" >
                                  <a class="btn btn-light nav-link w-50 active" id="day" :style="{ 'text-decoration': 'none', 'padding': '4px', 'background-color': '#F7F7F7' }" href="javascript:void(0)" role="tab" data-toggle="tab" @click="changeFilterType('Day')">Day</a>
                                  <a class="btn btn-light nav-link w-50" id="week" :style="{ 'text-decoration': 'none', 'padding': '4px', 'background-color': '#F7F7F7' }" href="javascript:void(0)" role="tab" data-toggle="tab" @click="changeFilterType('Week')">Week</a>
                                </div>
                                <div class="pt-3" :style="{ 'padding-right': '2px'}">
                                  <div class="input-group border">
                                          <div class="input-group-prepend">
                                              <div class="input-group-text" :style="{ 'background-color': 'white', 'border-left': 'unset','border-top': 'unset', 'border-bottom': 'unset' }" id="btnGroupAddon">
                                                  <a class="text-black" href="javascript:void(0)" @click="previousDate()">
                                                      <ArrowLeftIcon />
                                                  </a>
                                              </div>
                                          </div>
                                          <div class="form-control text-center" :style="{ 'border': 'unset', 'font-weight': 'bold' }">{{ this.formattedDate }}</div>
                                          <div class="input-group-prepend">
                                              <div class="input-group-text" :style="{ 'background-color': 'white', 'border-left': 'unset','border-top': 'unset', 'border-bottom': 'unset' }" id="btnGroupAddon">
                                                  <a class="text-black" href="javascript:void(0)" @click="nextDate()">
                                                      <ArrowRightIcon />
                                                  </a>
                                              </div>
                                          </div>
                                      </div>
                              </div>
                              </div>
                              <div class="profile-section" style="border-bottom: unset;">
                                  <div class="card" :style="{ 'border': 'unset' }">
                                      <div class="card-body" :style="{ padding: 'unset' }">
                                        <h6 class="text-black">
                                            <b>Screen Time: </b><span class="text-primary"><b>{{ totalUsedTimeInFormat }}</b> </span>
                                        </h6> 
                                          <CanvasJSChart :options="options" :styles="styleOptions"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <span v-else class="text-danger">Please install app first</span>
                      </div>
                  </div>
              </div>
              <div class="profile-section text-center">
                    Last Update: {{ lastUpdated }}
              </div>
              <div class="profile-section mb-2" >
                    <div class="collapse footer" id="dailyLimitPopup">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="text-black">
                                    <b>Daily Limit</b> <a href="javascript:void(0)" class="text-black" @click="closeDailyLimitPopup()">
                                      <CrossCloseIcon class="float-right pt-1 pr-2" /> 
                                    </a>
                                </h6><hr>
                                <p class="text-black">
                                  Once you set a daily limit, your child will only be able to use the app for the specified number of minutes each day.
                                </p>
                                <ul class="text-black">
                                  <li><b>Orange:</b> Time limit has been sent to the device</li>
                                  <li><b>Green:</b> Time limit has been successfully applied on the device</li>
                                  </ul>

                            </div>
                        </div>
                    </div>
              </div>
              <!-- Confirm Modal -->
              <div class="modal fade" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="confirmAccessModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title text-danger" id="confirmAccessModalLabel">Error <i class="fas fa-exclamation-triangle"></i></h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <div class="modal-body">
                          {{ error }}
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-primary" v-if="categoryId" @click="gotToCategory()">Go To Category</button>
                          <button type="button" class="btn btn-primary" v-if="!categoryId" @click="gotToSetting()">Go To Setting</button>
                      </div>
                      </div>
                  </div>
              </div>
              <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
          </div>
      </div>
    </div>
</template>
<script>
import ProfileService from "../../services/ProfileService";
import KidsService from "../../services/KidsService";
import StarRating from 'vue-star-rating'
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import ArrowDownIcon from '@/components/icons/ArrowDownIcon.vue'
import UserIcon from '@/components/icons/UserIcon.vue'
import UsersBlueIcon from '@/components/icons/UsersBlueIcon.vue'
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'
import ArrowLeftBackIcon from '@/components/icons/ArrowLeftBackIcon.vue'
import StarGoldIcon from '@/components/icons/StarGoldIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import CommentIcon from '@/components/icons/CommentIcon.vue'
import TrashIcon from '@/components/icons/TrashIcon.vue'
import ThumbsUpIcon from '@/components/icons/ThumbsUpIcon.vue'
import HandIcon from '@/components/icons/HandIcon.vue'
import InfoCircleIcon from '@/components/icons/InfoCircleIcon.vue'

export default {
  name: 'AppDetail',
  components: {
    KidHeader,
    KidFooter,
    StarRating,
    ArrowDownIcon,
    UserIcon,
    UsersBlueIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowLeftBackIcon,
    StarGoldIcon,
    CrossCloseIcon,
    CommentIcon,
    TrashIcon,
    ThumbsUpIcon,
    HandIcon,
    InfoCircleIcon
  },
  props: {
    notRated: {
        type: String,
        default: "./images/not-certified.png",
    },
    exportOrange: {
        type: String,
        default: "./images/experts-orange.png",
    },
    exportGreen: {
        type: String,
        default: "./images/experts-green.png",
    },
    sixteenPlus: {
        type: String,
        default: "./images/16-plus.png",
    },
    childPositiveSmile: {
        type: String,
        default: "./images/child-positive-smile.png",
    },
    childNeutralSmile:{
        type: String,
        default: "./images/child-neutral-smile.png",
    },
    childNegativeSmile:{
        type: String,
        default: "./images/child-negative-smile.png",
    },
    kidAvatar: {
      type: String,
      default: "./images/kids-avatar.png",
    }
  },
  data() {
    return {
      isDisabled: false,
      package_name: this.$route.query.package_name,
      profileId: this.$route.query.profile_id,
      serialNumber: this.$route.query.serialNumber,
      playstoreText: this.$route.query.playstoreText,
      filterCategory: this.$route.query.filterCategory,
      expertRatingFilter: this.$route.query.expertRatingFilter,
      ageFilter: this.$route.query.ageFilter,
      applicationDetail: null,
      enableDailyLimit: false,
      dailyLimitTime: 0,
      isAppEnabled: false,
      currentDate: new Date(),
      formattedDate: new Date().toLocaleDateString("en-US", this.$dateOptions),
      options: null,
      styleOptions: {
            width: "100%",
           
      },
      lastUpdated: "No data found.",
      deviceDetail: null,
      filterType: "Day",
      weekType: "Current",
      isEducational: 0,
      isPositive: 0,
      isSuitableContent: 0,
      isEasyToUnderstand: 0,
      review: "",
      isRecommend: null,
      isEasyToStop: null,
      isDeliveredToDevice: false,

      kidsRatingDetail: {},
      parentsRatingDetail: {},
      overallRating: 0,
      totalUsedTime: 0,
      totalUsedTimeInFormat: "",
      categoryId: null,
      error: "",
    }
  },
  methods: {
    async getApplicationDetail() {
      let data = {
        profile_id: this.profileId,
        package_name: this.package_name,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType,
        serialNumber: this.serialNumber,
      }
      await ProfileService.getApplicationDetail(data)
        .then((response) => {
          this.applicationDetail = response.data.data;
          this.kidsRatingDetail = response.data.kidsRating;
          this.overallRating = response.data.overallRating;
          this.parentsRatingDetail = response.data.parentRating;
          this.totalUsedTime = response.data.totalUsedTime;
          this.enableDailyLimit = this.applicationDetail.enableDailyLimit;
          this.dailyLimitTime = (this.applicationDetail.dailyLimitTime) ? this.applicationDetail.dailyLimitTime : 0;
          this.isDeliveredToDevice = (this.applicationDetail.fcmDetail) ? this.applicationDetail.fcmDetail.isDeviceAcknowledge : null;
          if (this.applicationDetail.appExist == true) {
            this.isAppEnabled = (this.applicationDetail.is_app_disabled == true) ? false : true;
          }
        }).catch((e) => {
          this.$toast.error(e);
        });
    },
    updateDailyLimit() {
      if (this.enableDailyLimit == true && ! this.dailyLimitTime) {
        return this.$toast.error("Please enter time.");  
      }
      if (this.dailyLimitTime % 15 != 0 ) {
        return this.$toast.error("Please enter time multiple of 15.");   
      } 
      let data = {
        profile_id: this.profileId,
        package_name: this.package_name,
        dailyLimitTime: this.dailyLimitTime,
        enableDailyLimit: this.enableDailyLimit,
        serialNumber: this.serialNumber,
      }
      ProfileService.updateDailyLimit(data)
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
          this.isDeliveredToDevice = false;
          this.applyPolicy();
          this.getApplicationDetail();
        }).catch((e) => {
          this.error = e.response.data.respones_msg;
          this.categoryId = e.response?.data?.data;
          if (this.categoryId) {
            $('#errorModal').modal('show');
          }
          if (e.response?.data?.showLimitErrorModal == true) {
            $('#errorModal').modal('show');
          }
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    gotToCategory() {
        $('#errorModal').modal('hide');
        this.$router.push({ path: '/category', query: { id: this.categoryId, profileId: this.profileId, serialNumber: this.serialNumber, appRequestPage: true }})
    },
    gotToSetting() {
      $('#errorModal').modal('hide');
      this.$router.push({ path: '/global-settings', query: { id: this.categoryId, profileId: this.profileId, serialNumber: this.serialNumber, appRequestPage: true }})
    },
    async createProfileApplication(app) {
        this.isDisabled = true;
        let masterApplicationData = {
            product_id: app.appId,
            package_name: app.appId,
            app_icon: app.icon,
            application_details: app,
            type: "Android",
        };
        await ProfileService.createMasterApplication(masterApplicationData)
        .then((response) => {
        }).catch((e) => {
        })

      let data = {
        profile_id: this.profileId,
        package_name: app.appId,
        is_web_app: false,
        type: "Android",
        serialNumber: this.serialNumber,
      };

      await ProfileService.createProfileApplication(data)
        .then((response) => {
            this.applyPolicy();
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.getApplicationDetail();
        })
        .catch((e) => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async uninstallProfileApplication(package_name) {
      this.isDisabled = true;
      var data = {
        package_name: package_name,
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.uninstallProfileApplication(data)
        .then(async (response) => {
            await this.applyPolicy();
            this.deleteProfileApplication(package_name);
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    deleteProfileApplication(package_name) {
        if (package_name == "com.nova.kidsfirstphone") {
          this.$toast.error("You don't have permission to uninstall this app");
          return;
        } 
        this.isDisabled = true;
        var data = {
          package_name: package_name,
          profile_id: this.profileId,
          serialNumber: this.serialNumber
        };

        ProfileService.deleteProfileApplication(data)
          .then((response) => {
              this.applyPolicy();
              this.isDisabled = false;
              this.$toast.success(response.data.respones_msg);
              this.getApplicationDetail();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },

    async applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },

    async getAppUsageChart() {
        let data = {
        profileId: this.profileId,
        serialNumber: this.serialNumber,
        packageName: this.package_name,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getAppUsageChart(data)
        .then((response) => {
            this.options = response.data.data
            this.deviceDetail = response.data.deviceDetail;
            if (this.deviceDetail && this.deviceDetail.lastDeviceActivationDate) {
                this.lastUpdated = new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
            } else {
                this.lastUpdated = "No data found.";
            }
            this.totalUsedTimeInFormat = response.data.totalUsedTimeInFormat;
        }).catch((e) => {
          this.$toast.error(e);
        });
    },
    changeFilterType(type) {
        this.filterType = type;
        if (this.filterType == "Day") {
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
        } else {
            this.formattedDate = "This Week";
            this.weekType = "Current";
        }
    },
    previousDate() {
      if (this.filterType == "Day") {
        let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
        this.currentDate.setTime(day);
        this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
      } else {
          this.formattedDate = "Previous Week"
          this.weekType = "Previous";
      }
      this.getAppUsageChart();
    },
    nextDate() {
      if (this.filterType == "Day") {
        let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
        this.currentDate.setTime(day);
        this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions)
      } else {
        this.formattedDate = "This Week",
        this.weekType = "Current";    
      }  
      this.getAppUsageChart();
    },
    closeRatingPopup() {
        $('#reviewPopup').collapse('hide');
    },
    updateIsEasyToStop(value) {
      this.isEasyToStop = value;
    },
    updateIsRecommend(value) {
      this.isRecommend = value;
    },
    submitParentRating() {
      this.isDisabled = true;
      let data = {
        packageName: this.package_name,
        isEducational: this.isEducational,
        isPositive: this.isPositive,
        isEasyToStop: this.isEasyToStop,
        isSuitableContent:this.isSuitableContent,
        isEasyToUnderstand: this.isEasyToUnderstand,
        isRecommend: this.isRecommend,
        review: this.review,
        profileId: this.profileId
      };

      KidsService.submitParentRating(data)
        .then((response) => {
          this.isDisabled = false;
          this.getApplicationDetail();
          $('#reviewPopup').collapse('hide');
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateAppRecommendations(isRecommended) {
      this.isDisabled = true;
      let data = {
        packageName: this.package_name,
        isRecommend: isRecommended,
      };

      KidsService.updateAppRecommendations(data)
        .then((response) => {
          this.isDisabled = false;
          this.getApplicationDetail();
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    toggleAppStatus() {
      if (this.enableDailyLimit == true && this.isAppEnabled == true && this.totalUsedTime >= this.dailyLimitTime) {
          this.isAppEnabled = false;
          return this.$toast.error("Please increase daily limit time to enable this category.");  
      }
      var data = {
          application_id: this.applicationDetail._id,
          is_app_disabled: (this.isAppEnabled == true) ? false : true,
          serialNumber: this.serialNumber  
        };

        ProfileService.toggleProfileAppStatus(data)
          .then((response) => {
              this.applyPolicy();
              this.isDisabled = false;
              this.$toast.success(response.data.respones_msg);
              this.getApplicationDetail();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },

    timeSince(previous) {
      var msPerMinute = 60 * 1000;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;
      let current = Date.now();
      var elapsed = current - previous;

      if (elapsed < msPerMinute) {
          return Math.round(elapsed/1000) + ' seconds ago';   
      }

      else if (elapsed < msPerHour) {
          return Math.round(elapsed/msPerMinute) + ' minutes ago';   
      }

      else if (elapsed < msPerDay ) {
          return Math.round(elapsed/msPerHour ) + ' hours ago';   
      }

      else if (elapsed < msPerMonth) {
          return Math.round(elapsed/msPerDay) + ' days ago';   
      }

      else if (elapsed < msPerYear) {
          return Math.round(elapsed/msPerMonth) + ' months ago';   
      }

      else {
          return Math.round(elapsed/msPerYear ) + ' years ago';   
      }

    },
    formatNumber(number) {
      const formatCash = Intl.NumberFormat('en-US', {
        notation: "compact",
        maximumFractionDigits: 1
      }).format(number);
      return formatCash;
    },
    decreaseLimit() {
        if (this.dailyLimitTime > 0) {
            this.dailyLimitTime = this.dailyLimitTime - 15
            if (this.dailyLimitTime == 0) {
              this.enableDailyLimit = false;      
            }
        } else {
          this.enableDailyLimit = false;  
        }
        this.updateDailyLimit();
    },
    increaseLimit() {
        this.enableDailyLimit = true;
        this.dailyLimitTime = (parseInt(this.dailyLimitTime) + 15)
        this.updateDailyLimit();
    },
    openDailyLimitPopup() {
        $('#dailyLimitPopup').collapse('show')
    }, 
    closeDailyLimitPopup(){
        $('#dailyLimitPopup').collapse('hide')
    },
    roundOF15() {
        this.dailyLimitTime = Math.ceil(this.dailyLimitTime/15.0) * 15;
    },
    HumanReadableDateFormat(date, onlyDate = false) {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sept", "Oct", "Nov", "Dec"
        ];
        let dt = new Date(date);
        if (dt == "Invalid Date") {
            return "-";
        }
        let day = ("0" + dt.getDate()).slice(-2);
        let month = dt.getMonth();
        let year = dt.getFullYear();
        let hour = ("0" + dt.getHours()).slice(-2);
        let minute = ("0" + dt.getMinutes()).slice(-2);
        let seconds = ("0" + dt.getSeconds()).slice(-2);
        if (onlyDate) {
            return month + "/" + year;
        } else {
            return day + " " + monthNames[month] + " " + year + " " + hour + ":" + minute + ":" + seconds;
        }
    },
    
    getReasonText(type) {
      switch (type) {
        case 'Manually':
          return 'manually';
        case 'Overuse':
          return 'due to app time limit';
        case 'Category Overuse':
          return 'due to category time limit';
        case 'Cronjob':
          return 'via schedule';
        case 'Global Daily Limit Reach':
          return 'due to device time limit';
        default:
          return '';
      }
    }
  },
  watch: {
    enableDailyLimit() {
        if (this.enableDailyLimit == false) {
          //this.dailyLimitTime = 0
        } else {
          this.dailyLimitTime = (this.applicationDetail.dailyLimitTime) ? this.applicationDetail.dailyLimitTime : 15;
        }
    },
    dailyLimitTime() {
        if (this.dailyLimitTime < 0) {
            this.dailyLimitTime = 0;
        }
    },
    filterType() {
        this.getAppUsageChart();
    },
  },
  beforeMount() {
    this.getApplicationDetail();
    this.getAppUsageChart();
    let showRating = this.$route.query.showRating;
    if (showRating == 'true') {
      setTimeout(function() {
          $('#reviewPopup').collapse('show');
      }, 2500); 
    }
  }, 
  mounted: function () {
    this.$nextTick(() => {
      const that = this;
      $("#usageTab").on("click", function() {
          $("#week")[0].click();
          setTimeout(function(){
              $("#day")[0].click();
          }, 400); 
      });
    })
  }
}
</script>
<style scoped>
.system-app-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 12px 16px;
  border-radius: 6px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  margin-top: 10px;
  display: inline-block;
}
.status-text {
  line-height: 1.5; /* or 1.6 */
  font-size: 0.875rem;
}
.input-group-text{
  padding: 5px;
}
</style>